import React from 'react';
import Head from 'next/head';

interface NextSEOHeaderProps {
  title: string;
  description: string;
  canonical: string;
  keywords?: string;
  imageUrl?: string;
  schema?: string;
}

export const NextSEOHeader: React.FC<NextSEOHeaderProps> = ({
  title,
  description,
  canonical,
  keywords,
  imageUrl,
  schema,
}) => {
  return (
    <Head>
      <title key="meta-title">{title}</title>
      <meta name="description" content={description} key="description" />
      <link rel="canonical" href={canonical} key="canonical" />
      {keywords && <meta name="keywords" content={keywords} key="keywords" />}
      <meta property="og:title" content={title} key="og:title" />
      <meta property="og:description" content={description} key="og:description" />
      <meta property="og:type" content="website" key="og:type" />
      <meta property="og:url" content={canonical} key="og:url" />
      <meta property="og:locale" content="en_US" key="og:locale" />
      <meta property="og:site_name" content="zola.com" key="og:site_name" />
      <meta property="og:phone_number" content="1-408-657-ZOLA" key="og:phone_number" />
      {imageUrl && <meta property="og:image" content={imageUrl} key="og:image" />}
      <meta property="fb:app_id" content="215495315286955" key="fb:app_id" />
      <meta name="twitter:title" content={title} key="twitter:title" />
      <meta name="twitter:description" content={description} key="twitter:description" />
      <meta name="twitter:site" content="@zola" key="twitter:site" />
      <meta name="twitter:creator" content="@zola" key="twitter:creator" />
      {imageUrl && <meta name="twitter:image" content={imageUrl} key="twitter:image" />}
      {imageUrl && <meta name="twitter:card" content="summary_large_image" key="twitter:card" />}
      {schema && <script type="application/ld+json">{schema}</script>}
    </Head>
  );
};
